// extracted by mini-css-extract-plugin
export default {"resetButton":"X_JDMJ9","root":"Wj6P95v","inactive":"i3_yCWY"};